export default __webpack_public_path__ + "static/media/car.dc483c59.png";